"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStruct = exports.InvoiceItemStruct = void 0;
const superstruct_1 = require("superstruct");
exports.InvoiceItemStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    /**
     * Used to sort items in invoice
     **/
    sortLabel: (0, superstruct_1.string)(),
    /**
     * Stripe customer id
     */
    customer: (0, superstruct_1.string)(),
    /**
     * Stripe invoice id
     */
    invoice: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    /**
     * The integer amount in EUR of the charge to be applied to the upcoming invoice.
     */
    amount: (0, superstruct_1.number)(),
    /**
     * The integer amount in EUR of the charge to be applied to the upcoming invoice.
     */
    unit_amount: (0, superstruct_1.number)(),
    /**
     * Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies).
     */
    currency: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    /**
     * An arbitrary string which you can attach to the invoice item. The description is displayed in the invoice for easy tracking.
     */
    description: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    /**
     * The period associated with this invoice item. When set to different values, the period will be rendered on the invoice. If you have [Stripe Revenue Recognition](https://stripe.com/docs/revenue-recognition) enabled, the period will be used to recognize and defer revenue. See the [Revenue Recognition documentation](https://stripe.com/docs/revenue-recognition/methodology/subscriptions-and-invoicing) for details.
     */
    period: (0, superstruct_1.type)({
        start: (0, superstruct_1.number)(),
        end: (0, superstruct_1.number)(), // timestamp in seconds
    }),
    /**
     * Non-negative integer. The quantity of units for the invoice item.
     */
    quantity: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    /**
     * The ID of a subscription to add this invoice item to. When left blank, the invoice item will be be added to the next upcoming scheduled invoice. When set, scheduled invoices for subscriptions other than the specified subscription will ignore the invoice item. Use this when you want to express that an invoice item has been accrued within the context of a particular subscription.
     */
    subscription: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.InvoiceStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    billingPeriodStart: (0, superstruct_1.string)(),
    billingPeriodEnd: (0, superstruct_1.string)(),
    stripeInvoiceId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    stripeCustomerId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    stripeCustomerEmail: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    invoiceItems: (0, superstruct_1.array)(exports.InvoiceItemStruct),
});
//# sourceMappingURL=invoice.js.map